import { Typography } from '@/components/common';
import { UploadDocument } from '@/components/dashboard';
import { InputDate, InputText } from '@/components/form';
import { getYear } from 'date-fns';
import * as React from 'react';
import {
	FieldError,
	FieldErrorsImpl,
	FieldValues,
	Merge,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

interface UploadNewTabProps {
	file: File | null;
	setFile: React.Dispatch<React.SetStateAction<File | null>>;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	documentNameError?:
		| FieldError
		| Merge<FieldError, FieldErrorsImpl<FieldValues>>;
	documentNameRules: Record<string, unknown>;
}

export const UploadNewTab: React.FC<UploadNewTabProps> = ({
	file,
	setFile,
	register,
	setValue,
	watch,
	documentNameError,
	documentNameRules,
}) => {
	return (
		<>
			<UploadDocument
				id="document"
				typeDocument="document"
				variant="pill"
				file={file}
				setFile={setFile}
				classNameDescription="!max-w-[270px]"
				accept=".pdf"
				maxFileSizeInMB={25}
				errorMaxSizeMessage="The maximum file size is 25 MB."
			/>
			<Typography type="semibold-16" className="text-black text-left !mt-6">
				Settings
			</Typography>
			<InputText
				register={register}
				name="document_name"
				title="Document name"
				customPlaceholder="Enter Document Name"
				maxLength={255}
				rules={documentNameRules}
				error={documentNameError}
				classNameInput="!h-12"
			/>
			<div className="send-document-date-input">
				<InputDate
					register={register}
					name="sign_by_date"
					title="Complete by date"
					additionalInfoTitle="(optional)"
					setValueInput={setValue}
					fromDate={new Date()}
					startYear={getYear(new Date())}
					dateDefault={watch('sign_by_date')}
					value={watch('sign_by_date')?.replace(/-/g, '/')}
					classNameInput="!h-12 !text-black"
				/>
			</div>
			<style>{`
				.send-document-date-input input::placeholder {
					color: rgba(13, 6, 22, 0.2) !important;
				}
			`}</style>
		</>
	);
};

export default UploadNewTab;
